export const WATERMARK_TEXT = 'Generated with www.worldmapgenerator.com (Licence: CC BY-NC-SA 4.0)'

export function getWatermarkFontSize(width) {
  switch (true) {
    case width >= 600:
      return 14
    case width >= 400:
      return 10
    default:
      return 0
  }
}

export function findLayerStyle(theme, layer) {
  const result = theme.layerStyleList.find(({ layerIds }) => layerIds.includes(layer.id))

  if (!result) {
    throw new Error(`Layer style for layer id "${layer.id}" not found!`)
  }

  return result
}

export function getDrawMethod(drawMethodList, layerId) {
  const defaultDrawMethod = drawMethodList.find(({ id }) => !id)
  const targetDrawMethod = drawMethodList.find(({ id }) => id === layerId)

  return targetDrawMethod || defaultDrawMethod
}
